import { Box, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material'
import { useOnboarding } from '../../context/OnboardingContext'
import { BodyText, StepCard } from '../../components/ui'
import { ONBOARDING_SESSION_DAYS } from '../../lib/prototypeSettings'
import { daysRemaining } from '../../lib/session'

/** Design manual p.3 — Important Information. */
export function StepImportant() {
  const { state, dispatch } = useOnboarding()

  return (
    <StepCard>
      <Typography component="h3" sx={{ fontSize: { xs: '1.125rem', sm: '1.25rem' }, fontWeight: 600, color: '#0f172a' }}>
        <span aria-hidden>🚨</span> Important Message <span aria-hidden>🚨</span>
      </Typography>
      <Stack spacing={2.5} sx={{ mt: 2.5 }}>
        <BodyText sx={{ fontWeight: 700 }}>
          It is essential that you remain current on all surplus lines tax filing and state reporting requirements.
        </BodyText>
        <BodyText>
          Please note that MISC is not responsible for filing obligations that arise during or prior to the implementation
          period.
        </BodyText>
        <BodyText>
          You may save your progress and exit at any time. You may return to continue onboarding by logging back into your
          onboarding portal account.
        </BodyText>

        <Box sx={{ borderRadius: 2, border: '1px solid #e2e8f0', bgcolor: '#f8fafc', p: 2.5 }}>
          <Typography sx={{ fontSize: 15, fontWeight: 600, color: '#0f172a' }}>Onboarding Timeline</Typography>
          <BodyText sx={{ mt: 1 }}>
            Your Onboarding Checklist Assistant will remain active for{' '}
            <strong>{ONBOARDING_SESSION_DAYS} Days</strong> ({daysRemaining(state.startedAt)} days remaining).
          </BodyText>
          <BodyText sx={{ mt: 1 }}>
            We encourage you to complete onboarding as soon as possible so that a Go-Live date can be scheduled.
          </BodyText>
          <BodyText sx={{ mt: 1 }}>If additional time is needed, please contact our team for an extension.</BodyText>
        </Box>

        <FormControlLabel
          control={
            <Checkbox
              checked={state.importantAcknowledged}
              onChange={(e) => dispatch({ type: 'SET_IMPORTANT_ACK', value: e.target.checked })}
            />
          }
          label={<Typography sx={{ fontSize: 15, fontWeight: 500 }}>I understand and acknowledge the information above.</Typography>}
        />
      </Stack>
    </StepCard>
  )
}
